import { Text, Link } from '@comicrelief/component-library';
import { StyledAccordion } from '../global/Global.style';

export default function InformationSection() {
  return (
    <StyledAccordion title="Why do we collect this information?" textTag="p" weight="700">

      <Text tag="p" size="xs" textAlign="center">Name, surname, email and billing address: we need these to process your payment, create a receipt and send it to you. We’ll also use it to claim Gift Aid, if you’ve told us to.</Text>

      <Text tag="p" size="xs" textAlign="center">
        Your details will be kept safe and never shared with other organisations; see our
        {' '}
        <Link href="https://www.comicrelief.com/privacy-policy" rel="noopener noreferrer" target="blank">
          privacy policy
        </Link>
        .
      </Text>

    </StyledAccordion>
  );
}
